module.exports = __webpack_public_path__ + "media/images/lb/045-2a474e9141b9f1adef45f370d17d4763.svg";